$(document).ready(function() {

});

$(document).delegate(".clickable", "click", function(e) {
	href = $(this).find("a").attr('href');
	target = $(this).find("a").attr('target');
	if (target == "_blank") {
		window.open(href, '_blank');
	} else {
		window.location = href;
	}
});

/* ===============
   HREF#
   =============== */

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});
